import { useEffect, useState } from 'react';
import ContentFiles from "src/content";

export function formatContentText(text: string) {
  const lines = text.split('\n');
  const metaDataLines = lines.slice(1,4);
  const metaData = metaDataLines
    .map(str => {
      const [key, ...rest] = str.split(':');
      return {[key]: rest.join(':').trim()};
    })
    .reduce((acc, curr) => ({...acc, ...curr}), {});
  const contentText = lines.slice(5).join('\n');

  return {metaData, contentText};
}

export function useContentData (contentType: string, slug: string) {
  let [contentData, setContentData] = useState('');
  let [metaData, setMetaData] = useState({});
  let [isReactComponent, setIsReactComponent] = useState(false);
  
  useEffect(() => {
    if (slug.length > 0 && !ContentFiles[contentType][slug]) {
      setMetaData({error: "invalid slug"});
    } else if (slug.length === 0) {
      setMetaData({error: "no slug defined"});
    } else {
      const fileInfo = ContentFiles[contentType][slug];
      const isJsx = fileInfo.file.endsWith('.jsx');
      setIsReactComponent(isJsx);
      
      if (isJsx) {
        // For JSX components, just set metadata - component loading handled elsewhere
        setMetaData({
          title: fileInfo.title,
          date: fileInfo.date,
          isReactComponent: true
        });
        setContentData(''); // No content data needed for JSX
      } else {
        // Load markdown content
        const loadMarkdown = async () => {
          try {
            const articleModule = await import(`../content/${contentType}/${slug}.md`);
            const rawText = articleModule.default;
            const { metaData, contentText } = formatContentText(rawText);
            setContentData(contentText);
            setMetaData(metaData);
          } catch (err) {
            console.error("Failed to load markdown file:", err);
          } 
        };
        loadMarkdown();
      }
    }
  }, [slug]);

  return [metaData, contentData, isReactComponent];
};

